export function compareId(id1: string, id2: string) {
  if (id1 === id2) {
    return 0;
  }

  if (id1.length === id2.length) {
    return id1 > id2 ? 1 : -1;
  } else {
    return id1.length > id2.length ? 1 : -1;
  }
}

export function idsMatch(
  id1: string | number | null | undefined,
  id2: string | number | null | undefined,
) {
  if (id1 == null || id2 == null) {
    return false;
  }

  return String(id1) === String(id2);
}
